import React, { useEffect } from 'react';
import Convocacao from "pages/Convocacao";
import Faq from "pages/Faq";
import TextoPresidente from "components/TextoPresidente";
import Inicio from "pages/Inicio";
import NaoEncontrada from "pages/NaoEncontrada";
import MateriaisTecnicos from "pages/MateriaisTecnicos";
import PaginaBase from "pages/PaginaBase";
import Contato from "pages/Contato";
import { BrowserRouter, Route, Routes, useLocation  } from "react-router-dom";
import Parceiros from "pages/Parceiros";
import Normativas from "pages/Normativas";
import ObtencaoDeRecursos from "pages/Internas/ObtencaoDeRecursos";
import InstrumentosDePlanejamento from "pages/Internas/InstrumentosDePlanejamento";
import OpiniaoDosContadores from "pages/Internas/OpiniaoDosContadores";
import CriacaodoFia from "pages/Internas/CriacaodoFia";
import CenarioMunicipal from "pages/Internas/CenarioMunicipal";
import PotencialdeArrecadacao from "pages/Internas/PotencialdeArrecadacao"
import SaibaComo from "components/SaibaComo";
import SaibaMais from "components/SaibaMais";
import LerNoticia from "components/Noticias/LerNoticia";
import { trackPageView } from "./analytics";



const Analytics = () => {
    const location = useLocation();

    useEffect(() => {
      trackPageView(location.pathname + location.search);
    }, [location]);

    return null;
  };

  function AppRoutes() {
    return (

        <BrowserRouter>
        <Analytics />
            <Routes>
                <Route path="/" element={<PaginaBase />}>
                    <Route path="*" element={<NaoEncontrada />}></Route>
                    <Route index element={<Inicio />}></Route>
                    {/* <Route path="noticias" element={<Noticias />}></Route> */}
                    <Route path="/noticia/:noticiaId" element={<LerNoticia />} />
                    <Route path="convocacao" element={<Convocacao />}></Route>
                    <Route path="normativas" element={<Normativas />}></Route>
                    <Route path="parceiros" element={<Parceiros />}></Route>
                    <Route path="faq" element={<Faq />}></Route>
                    <Route path="materiais-tecnicos" element={<MateriaisTecnicos />}></Route>
                    <Route path="contato" element={<Contato />} ></Route>
                    {/* internas */}
                    <Route path="obtencao-de-recursos" element={<ObtencaoDeRecursos />}></Route>
                    <Route path="instrumentos-de-planejamento" element={<InstrumentosDePlanejamento />}></Route>
                    <Route path="opiniao-contadores" element={<OpiniaoDosContadores />}></Route>
                    <Route path="criacao-do-fia" element={<CriacaodoFia />}></Route>
                    <Route path="cenario-municipal" element={<CenarioMunicipal />}></Route>
                    <Route path="potencial-de-arrecadacao" element={<PotencialdeArrecadacao />}></Route>
                    <Route path="saiba-como" element={<SaibaComo />}></Route>
                    <Route path="saiba-mais" element={<SaibaMais />}></Route>
                    <Route path="/palavraspresidente" element={<TextoPresidente />}></Route>
                </Route>
            </Routes>
        </BrowserRouter>
    )
}

export default AppRoutes;
